<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('documents.DocCancelByCreditNote.cancel_by_credit_note')"
        class="doc-cancel-by-credit-note"
        @closed="$emit('update:visible', false)"
    >
        <template #default>
            <div class="dialog__default">
                <p class="typographies-paragraph-medium-regular">
                    {{ $l10n.__('Vous allez annuler cette facture par la création d‘un avoir.') }}
                </p>
                <p class="typographies-paragraph-medium-regular">
                    {{ $l10n.__('L‘avoir va se créer automatiquement.') }}
                </p>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="$emit('update:visible', false)"
                />
                <CompassButton
                    :label="$t.__('documents.DocCancelByCreditNote.create_credit_note')"
                    type="primary"
                    :loading="loading"
                    class="ml-3"
                    :data-bot="dataBot"
                    @click="cancel"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
export default {
    props: {
        isProgressInvoice: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: true,
            loading: false,
        };
    },
    computed: {
        dataBot() {
            return this.isProgressInvoice
                ? 'document-overview-progress-invoice--create-credit-note'
                : '';
        },
    },
    methods: {
        cancel() {
            this.loading = true;

            this.$store
                .dispatch('documentOverview/cancelInvoiceByCreditnote')
                .then(() => {
                    location.reload();
                })
                .catch(() => (this.loading = false));
        },
    },
};
</script>

<style lang="scss" scoped>
.doc-cancel-by-credit-note {
    .dialog {
        &__default {
            padding-bottom: 24px;
            p {
                margin: 0;
                &:first-child {
                    margin-bottom: var(--spacing-3);
                }
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}
</style>
